import { z } from "zod";
import { budgetTypeList } from "@/types";

const schema = z.object({
  candidate: z.string({ required_error: "A candidate must be selected" }),
  agreesWithScope: z.boolean().optional(),
  agreesWithBudget: z.boolean().optional(),
  agreesWithStartDate: z.boolean().optional(),
  scope: z.string().optional(),
  budgetType: z.enum(budgetTypeList).optional(),
  budgetHourly: z.string().optional(),
  budgetMonthly: z.string().optional(),
  startDate: z.date().optional(),
  matchCriteria: z.string().array().optional(),
  matchCriteriaQuote: z.string().array().optional(),
  personalityRoleStrength: z.string().optional(),
  personalityRoleStrengthDetail: z.string().optional(),
  behaviorRoleStrength: z.string().optional(),
  behaviorRoleStrengthDetail: z.string().optional(),
  motivatorRoleStrength: z.string().optional(),
  motivatorRoleStrengthDetail: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as adminAddCandidateToJobFormSchema,
  type Schema as AdminAddCandidateToJobFormSchema,
};
